import React, {createContext, useReducer} from 'react'
import {LineHaulFilterReducer} from "../reducers/LineHaulFilterReducer";

export const LineHaulFilterContext = createContext();

const LineHaulFilterContextProvider = (props) => {
    const filterState = {
        Split : [],
        PackageSize : [],
        EAD : [],
        Cycle : [],
        Cluster : [],
        OtherAttributes : [],
        Filters: {
            PackageSize : [],
            EAD : [],
            Cluster : [],
            OtherAttributes : [],
            Cycle : []
        }
    }
    const [filter, dispatch ] = useReducer(LineHaulFilterReducer, filterState)
    return (
        <LineHaulFilterContext.Provider value = {{filter, dispatch}}>
            {props.children}
        </LineHaulFilterContext.Provider>
    )
}

export default LineHaulFilterContextProvider


// WEBPACK FOOTER //
// ./src/components/linehaul/context/LineHaulFilterContext.js